import type { FormErrors, UseFormReturnType } from '@mantine/form'

import { getObjectKeys } from './objects'

export function isFieldsListValid<T extends UseFormReturnType<any>>(
  form: T,
  fields: (keyof T['values'])[],
  errors: FormErrors = form.errors,
): boolean {
  const errorKeys = getObjectKeys(errors)

  return fields.every(f => {
    const v = form.values[f]

    return v !== undefined && v !== null && v !== '' && !errorKeys.includes(f as string)
  })
}

export function createRNInputProps(
  props: ReturnType<UseFormReturnType<any>['getInputProps']>,
  defaults?: { helper?: string },
): {
  defaultValue: string | undefined
  value: string | undefined
  status: 'error' | undefined
  helper: string | undefined
  onChangeText: (text: string) => void
  onFocus: () => void
  onBlur: () => void
} {
  return {
    defaultValue: props.defaultValue,
    value: props.value,
    status: props.error ? 'error' : undefined,
    helper: props.error || defaults?.helper || undefined,
    onChangeText: (text: string) => props.onChange(text),
    onFocus: () => props.onFocus(),
    onBlur: () => props.onBlur(),
  }
}
